<template>
  <div>
    <LanguageSelector />
    <div class="content-header row"></div>
    <div class="content-body">
      <Alert
        v-if="errorPayments"
        :text="`$t('ops contract') ${this.$route.query.c} $t('not found')`"
        type="danger"
        dismissable="true"
      />
      <section id="basic-datatable">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-content">
                <div class="card-header">
                  <h5 class="card-title">{{ $t("Manage Contracts") }}</h5>
                  <div class="heading-elements">
                    <ul class="list-inline mb-0">
                      <li class="marginLi" >
                        <legend class="has-icon-left">
                          <select
                            class="form-control"
                            v-model="countryFilter"
                            @change="filterByData()"
                          >
                            <option selected>
                              {{ $t("All Countries...") }}
                            </option>
                            <option
                              v-for="(country, index) in usersCountries"
                              :value="country"
                              :key="index"
                            >
                              {{ countryName(country) }}
                            </option>
                          </select>
                          <div class="form-control-position">
                            <em class="bx bx-map font-medium-1"></em>
                          </div>
                        </legend>
                      </li>
                      <li class="marginLi">
                        <div class="has-icon-left">
                          <select
                            class="form-control"
                            v-model="statusFilter"
                            @change="filterByData()"
                          >
                            <option selected>{{ $t("All Status...") }}</option>
                            <option value="sent">{{ $t("Sent") }}</option>
                            <option value="active">{{ $t("Active") }}</option>
                            <option value="expired">{{ $t("Expired") }}</option>
                            <option value="void">{{ $t("Void") }}</option>
                          </select>
                          <div class="form-control-position">
                            <em class="bx bx-filter font-medium-1"></em>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="has-icon-left">
                          <input
                            type="text"
                            class="form-control"
                            @keyup="searchInTable()"
                            v-model="searchInputText"
                            :placeholder="$t('Search...')"
                          />
                          <div class="form-control-position">
                            <em class="bx bx-search font-medium-1"></em>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="card-body card-dashboard">
                  <div class="text-center">
                    <div
                      class="spinner-border text-primary"
                      role="status"
                      v-if="loadingData"
                      style="opacity: 0.6"
                    >
                      <span class="sr-only">{{ $t("Loading...") }}</span>
                    </div>
                  </div>
                  <div
                    class="text-center mt-1"
                    v-if="!contracts.length && !loadingData"
                  >
                    <p>{{ $t("No Contracts Found...") }}</p>
                  </div>
                  <div class="table-responsive" v-if="contracts.length">
                    <table class="table zero-configuration" :aria-label="$t('contracts_arial_label_contract_list')">
                      <thead>
                        <tr>
                          <th>{{ $t("Name") }}</th>
                          <th>{{ $t("Country") }}</th>
                          <th>{{ $t("Status") }}</th>
                          <th>{{ $t("Landlord") }}</th>
                          <th>{{ $t("Tenant") }}</th>
                          <th>{{ $t("Rent Start") }}</th>
                          <th>{{ $t("Duration") }}</th>
                          <th>{{ $t("Property") }}</th>
                          <th>{{ $t("Created At") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(contract, index) in contracts" :key="index">
                          <td class="contractName capitalize">
                            <router-link
                              :to="{
                                name: 'ContractSinglePage',
                                params: { uuid: contract.id },
                              }"
                              href="#"
                              style="margin-top: 5px"
                            >
                              <span class="text-bold-500">{{
                                contract.name
                              }}</span>
                            </router-link>
                            <br />
                            <a
                              href="#"
                              style="margin-top: 5px"
                              @click="
                                getContractPayments(contract.id, contract)
                              "
                              >View Payments</a
                            >
                          </td>
                          <td>{{ countryName(contract.country) }}</td>
                          <td class="capitalize">
                            <span v-if="contract.status == 'sent'">
                              <em
                                class="bx bxs-circle info font-small-1 mr-50"
                              ></em>
                              {{ contract.status }}
                            </span>
                            <span v-if="contract.status == 'active'">
                              <em
                                class="bx bxs-circle success font-small-1 mr-50"
                              ></em>
                              {{ contract.status }}
                            </span>
                            <span v-if="contract.status == 'expired'">
                              <em
                                class="bx bxs-circle danger font-small-1 mr-50"
                              ></em>
                              {{ contract.status }}
                            </span>
                            <span v-if="contract.status == 'void'">
                              <em
                                class="
                                  bx
                                  bxs-circle
                                  light-secondary
                                  font-small-1
                                  mr-50
                                "
                              ></em>
                              {{ contract.status }}
                            </span>
                          </td>
                          <td>
                            {{
                              contract.landlord.name
                                ? contract.landlord.name
                                : "-"
                            }}
                          </td>
                          <td>
                            {{
                              contract.tenants[0].name
                                ? contract.tenants[0].name
                                : "-"
                            }}
                          </td>
                          <td>{{ contract.data.rentStart.split("T")[0] }}</td>
                          <td>{{ contract.data.contractDuration }} months</td>
                          <td>
                            {{
                              contract.property.name
                                ? contract.property.name
                                : "-"
                            }}
                          </td>
                          <td>{{ contract.createdAt.split("T")[0] }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div
      class="modal fade text-left"
      id="payments-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-modal-title"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
        :class="showCreatePaymentsForm === false ? 'modal-full' : 'modal-lg'"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3
              class="modal-title"
              id="create-modal-title"
              v-if="contractTarget.template"
            >
              "{{ contractTarget.template.details.en.name }}" - Payments
            </h3>
            <button
              type="button"
              class="close rounded-pill"
              data-dismiss="modal"
              aria-label="Close"
            >
              <em class="bx bx-x"></em>
            </button>
          </div>
          <div class="modal-body">
            <Alert
              v-if="errorText != ''"
              :text="errorText"
              type="danger"
              dismissable="false"
            />
            <div class="text-right">
              <!-- <button class="btn btn-primary" @click="toggleCreatePaymentsForm()" v-if="showCreatePaymentsForm === false" disabled> -->
              <button
                class="btn btn-primary"
                v-if="showCreatePaymentsForm === false"
                disabled
              >
                {{ $t("Log new payment") }}
              </button>
              <button
                class="btn btn-secondary"
                @click="toggleCreatePaymentsForm()"
                v-if="showCreatePaymentsForm === true"
              >
                {{ $t("Go back to payments") }}
              </button>
            </div>
            <div
              class="text-center mt-1"
              v-if="!payments.length && showCreatePaymentsForm === false"
            >
              <p>{{ $t("No Payments Found...") }}</p>
            </div>

            <div
              class="table-responsive mt-2"
              v-if="payments.length && showCreatePaymentsForm === false"
            >
              <table class="table payments-table" :aria-label="$t('contracts_arial_label_payment_list')">
                <thead>
                  <tr>
                    <th>{{ $t("Amount") }}</th>
                    <th>{{ $t("Date") }}</th>
                    <th>{{ $t("Status") }}</th>
                    <th>{{ $t("Reason") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(payment, index) in payments" :key="index">
                    <td class="text-bold-600">
                      {{ payment.amount }} {{ payment.currency }}
                    </td>
                    <td>{{ payment.date.split("T")[0] }}</td>
                    <td>
                      <span v-if="payment.status == 'confirmed'">
                        <em class="bx bxs-circle success font-small-1 mr-50"></em>
                        {{ $t("Confirmed") }}
                      </span>
                      <span v-if="payment.status == 'unconfirmed'">
                        <em class="bx bxs-circle danger font-small-1 mr-50"></em>
                        {{ $t("Unconfirmed") }}
                      </span>
                    </td>
                    <td>{{ payment.reason }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="showCreatePaymentsForm === true">
              <form>
                <div class="form-group">
                  <div class="row mt-2">
                    <div class="col-md-6 col-sm-12">
                      <label for="">{{ $t("Date") }}</label>
                      <div
                        class="form-group position-relative has-icon-left"
                      >
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('Select Date')"
                          id="date-payment"
                        />
                        <div class="form-control-position">
                          <em class="bx bx-calendar"></em>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <label for="">Currency</label>
                      <select class="form-control" v-model="paymentCurrency">
                        <option value="LBP">{{ $t("LBP") }}</option>
                        <option value="JOD">{{ $t("JOD") }}</option>
                        <option value="PLN">{{ $t("PLN") }}</option>
                        <option value="UAH">{{ $t("UAH") }}</option>
                        <option value="USD">{{ $t("USD") }}</option>
                        <option value="CAD">{{ $t("CAD") }}</option>
                        <option value="PEN">{{ $t("PEN") }}</option>
                        <option value="COP">{{ $t("COP") }}</option>
                        <option value="EUR">{{ $t("EUR") }}</option>
                      </select>
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <label for="">{{ $t("Amount") }}</label>
                      <input
                        type="number"
                        step="1.00"
                        min="0"
                        class="form-control"
                        v-model="paymentAmount"
                      />
                    </div>
                    <div class="col-md-6 col-sm-12">
                      <label for="">{{ $t("Reason") }}</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="paymentReason"
                      />
                    </div>
                  </div>
                  <div class="text-right mt-2">
                    <button
                      class="btn btn-primary"
                      type="button"
                      @click="logPayment()"
                    >
                      {{ $t("Save payment") }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryName } from "@/app-assets/js/get-countries.js";
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import Alert from "@/components/Alerts";
export default {
  data() {
    return {
      usersCountries: [],
      contracts: [],
      loadingData: true,
      countryFilter: "All Countries...",
      statusFilter: "All Status...",
      searchInputText: "",
      contractTarget: {},
      payments: [],
      showCreatePaymentsForm: false,
      errorText: "",
      errorPayments: false,

      paymentCurrency: "LBP",
      paymentAmount: "",
      paymentReason: "",
    };
  },

  components: {
    Alert,
  },

  computed: {
    isSuperadmin() {
      return this.$store.state.currentUser.user.type === "superadmin";
    },
  },

  methods: {
    getContracts() {
      this.loadingData = true;
      this.errorPayments = false;
      this.$apiCall
        .get("/v1/contracts/")
        .then((response) => {
          this.contracts = response.data.data;
          this.loadingData = false;
          response.data.data.map((el) => {
            if (!this.usersCountries.includes(el.country)) {
              this.usersCountries.push(el.country);
            }
          });
          this.initDataTable();

          if (this.$route.query.c) {
            const t = this.contracts.find((x) => x.id === this.$route.query.c);
            if (t) {
              this.getContractPayments(this.$route.query.c, t);
            } else {
              this.errorPayments = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filterByData() {
            let self = this;
            self.contracts = [];
            self.loadingData = true;
            let filterData = {};
            
           
             if (self.statusFilter != "All Status...") {
                filterData.status = self.statusFilter;
            }
            if (self.countryFilter != "All Countries...") {
                filterData.country = self.countryFilter;
            }
           
            if ( filterData.status || filterData.country ) {
                self.filterApiCall(filterData)
            }
            else {
                self.contracts = []
                self.usersCountries = [];
                self.getContracts();
            }
        },
        
                filterApiCall(data) {            
            let self = this;
            self.$apiCall
                .get(`/v1/contracts`, { params: data })
                .then(response => {
                    self.loadingData = false;
                    self.contracts = response.data.data;
                    self.initDataTable();
                })
        },
        

    getContractPayments(uuid, contract) {
      this.payments = [];
      this.showCreatePaymentsForm = false;
      this.contractTarget = contract;
      this.errorText = "";

      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });

      this.$apiCall
        .get(`/v1/contracts/contract/${uuid}/payments`)
        .then((response) => {
          $.unblockUI();
          this.payments = response.data.data;
          $("#payments-modal").modal();
          this.initPaymentsDataTable();
        })
        .catch((error) => {
          $.unblockUI();
          console.log(error);
        });
    },

    logPayment() {
      this.errorText = "";
      if (
        $("#date-payment").val() == "" ||
        this.paymentCurrency.trim() == "" ||
        this.paymentAmount.trim() == "" ||
        this.paymentReason.trim() == ""
      ) {
        this.errorText = "$t('Validation for the required fields')";
      } else {
        const body = {
          date: new Date($("#date-payment").val()).toISOString(),
          currency: this.paymentCurrency.toLowerCase(),
          amount: parseFloat(this.paymentAmount),
          reason: this.paymentReason,
        };

        var block_ele = $("#payments-modal .modal-content");
        $(block_ele).block({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait",
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent",
          },
        });

        this.$apiCall
          .post(
            `/v1/contracts/contract/${this.contractTarget.id}/payments`,
            body
          )
          .then((response) => {
            $(block_ele).unblock();
            this.getContractPayments(
              this.contractTarget.id,
              this.contractTarget
            );
            this.paymentAmount = "";
            this.paymentReason = "";
            this.paymentCurrency = "LBP";
            $("#date-payment").val("");
          })
          .catch((error) => {
            $(block_ele).unblock();
            this.errorText = `<strong>Ops!</strong> ${error.response.data.message}`;
          });
      }
    },

    toggleCreatePaymentsForm() {
      this.showCreatePaymentsForm = !this.showCreatePaymentsForm;
      this.errorText = "";

      if (!this.showCreatePaymentsForm) {
        this.initPaymentsDataTable();
      }

      setTimeout(() => {
        const pD = $("#date-payment").pickadate(
          {
            format: "mm/dd/yyyy",
          },
          200
        );
      });
    },

    searchInTable() {
      var value = this.searchInputText.toLowerCase();
      $(".zero-configuration > tbody tr").filter(function () {
        $(this).toggle(
          $(this).find(".contractName").text().toLowerCase().indexOf(value) > -1
        );
      });
    },

    filterByCountry(country) {
      let self = this;
      if (country != "All Countries...") {
        self.loadingData = true;
        self.contracts = [];
        self.$apiCall
          .get(`/v1/contracts?country=${country}`)
          .then((response) => {
            self.loadingData = false;
            self.contracts = response.data.data;
            self.initDataTable();
          });
      } else {
        self.contracts = [];
        self.usersCountries = [];
        self.getContracts();
      }
    },

    filterByStatus(status) {
      let self = this;
      if (status != "All Status...") {
        self.loadingData = true;
        self.contracts = [];
        self.$apiCall
          .get(`/v1/contracts?status=${status.toLowerCase()}`)
          .then((response) => {
            self.loadingData = false;
            self.contracts = response.data.data;
            self.initDataTable();
          });
      } else {
        self.contracts = [];
        self.usersCountries = [];
        self.getContracts();
      }
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    initDataTable() {
      setTimeout(function () {
        $(".zero-configuration").DataTable({
          // scrollX: true,
          bLengthChange: false,
          bFilter: false,
          order: [],
        });
      }, 100);
    },

    initPaymentsDataTable() {
      setTimeout(function () {
        $(".payments-table").DataTable({
          bLengthChange: false,
          bFilter: false,
          order: [],
        });
      }, 100);
    },
  },

  mounted() {
    let _this = this;
    this.getContracts();

    $("#payments-modal").on("hidden.bs.modal", function () {
      _this.showCreatePaymentsForm = true;
    });
  },
};
</script>

<style scoped>
table {
  white-space: nowrap;
}
.marginLi{
  margin-right: 1em
}
</style>